import { t } from '../i18n';
import { apiPath, FONT_UPLOAD_FILE_FIELD, type FontRecord, FontRecordSchema } from '@codot/contracts';
import { ApiError, refreshSession, request } from './http';

/** Custom fonts: multipart upload (one transparent refresh on 401), rename, delete. */
export const fontsApi = {
  list: (): Promise<FontRecord[]> => request('GET', apiPath('fonts'), FontRecordSchema.array()),
  async upload(file: File, name?: string): Promise<FontRecord> {
    const send = () => {
      const form = new FormData();
      if (name) form.append('name', name);
      form.append(FONT_UPLOAD_FILE_FIELD, file, file.name);
      return fetch(apiPath('fonts'), { method: 'POST', credentials: 'same-origin', body: form });
    };
    let res = await send();
    if (res.status === 401 && (await refreshSession())) res = await send();
    const body: unknown = await res.json().catch(() => undefined);
    if (!res.ok) throw new ApiError((body as { message?: string } | undefined)?.message ?? t('ui.uploadFailed', { status: res.status }), res.status, body);
    return FontRecordSchema.parse(body);
  },
  rename: (fontId: string, name: string): Promise<FontRecord> => request('PATCH', apiPath('font', { fontId }), FontRecordSchema, { name }),
  remove: (fontId: string): Promise<unknown> => request('DELETE', apiPath('font', { fontId }), null),
};
